<template>
  <section>
    <div
      class="radio-button-initial my-4 flex h-full flex-grow rounded-md border-2 border-off-white bg-off-white hover:border-light-gray"
      :class="[{ 'activeButton border': isChecked }]"
    >
      <label
        class="container-checkbox w-full"
        :class="{ activeButtonText: isChecked }"
        :for="'attestation-' + question_id"
      >
        <span
          v-html="question.subject"
          class="font-normal"
        ></span>

        <input
          :id="'attestation-' + question_id"
          v-model="isChecked"
          type="checkbox"
          @change="handleAttestationChange"
        />
        <span class="checkmark-checkbox" />
      </label>
    </div>

    <p
      v-if="question.description"
      class="mb-1 mt-2 text-xxs font-bold uppercase text-gray-over-dark"
    >
      {{ question.description }}
    </p>
  </section>
</template>

<script>
export default {
  name: 'AttestationCheckbox',
  props: {
    question: Object,
    question_id: Number,
    subject: String,
    setOnboardingPacket: Function,
    toggleRequired: Function,
    required: Boolean,
    conditional_children: Array,
    onboardingPacketId: Number,
  },
  emits: ['childCheck'],
  data() {
    return {
      isChecked: false,
    };
  },
  mounted() {
    const recentAnswer = this.question?.current_answer;
    if (recentAnswer && recentAnswer.string_value?.includes('Attested by')) {
      this.isChecked = true;
    }
  },
  methods: {
    handleAttestationChange() {
      if (this.required) {
        this.toggleRequired(this.question_id, this.isChecked);
      }
      const body = {
        company_question_id: this.question_id,
        string_value: this.isChecked ? 'true' : '',
      };
      this.setOnboardingPacket(body);
    },
  },
};
</script>

<style scoped>
.container-checkbox {
  @apply relative flex min-h-12 cursor-pointer items-start pb-3 pl-12 pr-4 pt-3.75 text-left text-xs text-body-color sm:text-sm;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.container-checkbox input {
  @apply absolute h-0 w-0 cursor-pointer opacity-0;
}

.checkmark-checkbox {
  @apply absolute left-2 h-6 w-6 rounded-md bg-white;
  top: 1.5rem;
  transform: translate(0, -50%);
}

.pre-validation .checkmark-checkbox {
  @apply border-white;
}

.pre-validation:hover .checkmark-checkbox {
  @apply border-light-gray;
}

.container-checkbox input:checked ~ .checkmark-checkbox {
  @apply bg-yellow-500;
}

.checkmark-checkbox:after {
  content: '';
  position: absolute;
  display: none;
}

.container-checkbox input:checked ~ .checkmark-checkbox:after {
  display: block;
}

.container-checkbox .checkmark-checkbox:after {
  left: 8px;
  top: 2px;
  width: 9px;
  height: 15px;
  border: solid white;
  border-width: 0 3px 3px 0;
  -webkit-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  transform: rotate(45deg);
}

.radio-button-initial.activeButton {
  @apply flex flex-wrap rounded-md border-2 border-yellow-500 bg-white;
  border-color: #f8c617 !important;
  background-color: white !important;
}

.activeButtonText {
  @apply text-dark-gray;
}
</style>
